<template>
    <div class="component-upload-container">
        <!-- 图片展示 -->
        <template v-if="image">
            <template v-if="multiple">
                <!--<span v-for="(item, index) in value">{{item}}</span>-->
                <div class="img-item-parent" :style="{
                        width,
                        height,
                        marginRight: '5px'
                    }" v-for="(item, index) in value" :key="index">
                    <img :src="item.url" :style="{ width, height }" @click="$openNewWindow(item.url)">
                    <div class="remove-parent" v-if="!$attrs.disabled">
                        <i class="el-icon-close" @click="removeConfirm(index)"></i>
                    </div>
                </div>
            </template>
            <template v-else>
                <!--<img :src="value" style="width: 100%; height: 100%;">-->
            </template>
        </template>
        <template v-else-if="$attrs.showFileList">
            <ul v-if="value && value.length > 0" class="component-attach-list">
                <li class="component-attach-item" v-for="(item, index) in value" v-if="item && item.oldname">
                    <ev-attachTypeIcon :type="$getAttachTypeByName(item.oldname)"></ev-attachTypeIcon>
                    <span :title="item.oldname">{{item.oldname}}</span>
                    <ev-attachDownLoad :url="item.url"></ev-attachDownLoad>
                    <!--<ev-attachRemove @click.native="removeConfirm(item)"></ev-attachRemove>-->
                </li>
            </ul>
        </template>

        <el-upload
                v-bind="$attrs"
                ref="fileUploadRef"
                class="upload-container-class"
                :class="{'image': image}"
                :action="url ||'/sys/attachment/upload'"
                :data="data"
                :headers="uploadHeaders"
                :before-upload="beforeUploadHandler"
                :on-success="uploadSuccessHandler"
                :on-error="uploadErrorHandler"
                :show-file-list="false"
                :style="image ? {
                    width,
                    height,
                    lineHeight: height
                } : {}"
                :file-list="fileList">
            <slot>
                <template v-if="image">
                    <i v-if="multiple" class="el-icon-plus"></i>
                    <template v-else="">
                        <img v-if="value" :src="value">
                        <template v-else="">
                            <i v-if="!$attrs.disabled" class="el-icon-plus" :title="title"></i>
                            <span v-else="" style="font-size: 12px; color: #999;">暂无图片</span>
                        </template>
                    </template>
                </template>
                <template v-else>
                    <template v-if="multiple">
                        <a target="_blank" class="file-item-link" @click.stop="" v-for="(item, index) in value || []" :key="index" :href="item.url || item.oldname || item" :title="item.name || item.oldname || item">{{ item.name || item.oldname || item }}</a>
                    </template>
                    <template v-else-if="value">
                        <a target="_blank" class="file-item-link" @click.stop="" :title="value.name || value.oldname || value" :href="value.name || value.oldname || value">{{ value.name || value.oldname || value }}</a>
                    </template>

                    <i class="el-icon-upload upload-icon" :title="title"></i>
                </template>
            </slot>

            <slot slot="tip" name="tip"></slot>
        </el-upload>
    </div>
</template>

<script>
    export default JBoot({
        name: 'new-upload',

        componentName: 'new-upload',

        registryName: 'new-upload',

        inject: ['elFormItem'],

        props: {
            url: String,
            title: {
                type: String,
                default: '点击选择文件上传'
            },
            value: {
                required: true,
            },
            data:{
                type: Object,
                required: false
            },
            echoFileRemove: {
                type: Function,
                default(file) {
                    return this.$api('common', 'removeAttach', [{id: file.id}]).catch(error => {
                        let errorMsg = error ? error.message || error.msg : '删除异常！';
                        this.$error(errorMsg);
                    });
                }
            },
            image: Boolean,
            multiple: Boolean,
            width: {
                type: String,
                default: '100px'
            },
            height: {
                type: String,
                default: '100px'
            },
            beforeUpload: Function,
            uploadSuccess: Function,
            removeFileIsRequest: Boolean
        },

        data() {
            return {
                fileList: [],
                uploadList: [],
                attachList: []
            }
        },
        computed: {
            uploadHeaders() {
                let headers = {};

                headers[this.$token.getTokenKey()] = this.$token.getToken();

                return headers;
            },

            uploadFiles() {
                return this.attachList.concat(this.value).filter(item => item);
            },

            uploadInstance() {
                return this.$getRef('fileUploadRef');
            }
        },

        methods: {
            getCaption(obj){
                let index=obj.lastIndexOf("\.");
                obj=obj.substring(index+1,obj.length);
                return obj;
            },
            beforeUploadHandler(file) {
                let fileName = this.getCaption(file.name)
                //console.log(fileName)
                if (fileName =='jpg' ||fileName =='png' ||fileName =='bmp' ||fileName =='jpeg'||fileName =='gif'){
                    this.attachList.push(file.data);
                    this.uploadSuccess && this.uploadSuccess();
                }else{
                    this.$error('上传图片只能是JPG / PNG / JPEG /BMP /GIF格式!');
                    return false
                }
               // console.log(123,file)
                this.beforeUpload && this.beforeUpload();
                this.uploadList.push(file.uid);
            },

            uploadSuccessHandler(response, file, fileList) {
                let fileName = this.getCaption(file.name)
                if (response) {
                    if (response.success && fileName =='jpg' ||fileName =='png' ||fileName =='bmp' ||fileName =='jpeg'||fileName =='gif') {
                       // console.info("response.data",response.data);
                        response.data.url = response.data.attachment;
                        this.attachList.push(response.data);
                        this.uploadSuccess && this.uploadSuccess();
                    }else{
                        //this.$error(response.message || '上传异常，请重试！');
                    }
                } else {
                    this.$error('上传异常，请重试！');
                }
                this.checkUploadComplete(file);
            },

            uploadErrorHandler(error, file, fileList) {

                this.checkUploadComplete(file);

                let errorMsg = '上传异常，请重试！';

                if (error && error.message) {
                    try {
                        let errorObj = JSON.parse(error.message);
                        let message = errorObj.message || errorObj.msg;
                        if (message) errorMsg = message;
                    } catch (e) {
                    }
                }

                this.$error(errorMsg);
            },

            checkUploadComplete(file) {
                this.uploadList = this.uploadList.filter(item => item !== file.uid);

                if (this.uploadList.length === 0) {
                    let result = this.uploadFiles;
                    if (this.image && !this.multiple) {
                        result = (result[0] || {}).url;
                    }
                    this.$emit('input', result);
                    if (this.elFormItem) {
                        this.elFormItem.$emit('el.form.change', result);
                    }
                    this.clearFiles();
                }
            },

            removeConfirm(index) {
                this.$isOk('删除确认', '是否要删除该文件？').then(() => {
                    this.removeFileHandler(index);
                })
            },

            removeFileHandler(index) {
                let na = [].concat(...this.value);

                na.splice(index, 1)

                this.$emit('input', na);
            },

            clearFiles() {
                if (this.uploadInstance) {
                    this.uploadInstance.clearFiles();
                }
                this.attachList = [];
            }
        },

        watch: {
            value: {
                immediate: true,
                handler(v, o) {
                    if (this.image) return;

                    if(this.multiple){
                        this.fileList = v || [];
                    }else{
                        this.fileList = v ? [{ uri: v }] : [];
                    }
                }
            }
        }
    }).build();
</script>

<style lang="scss">
    .component-upload-container {
        & > .img-item-parent{
            display: inline-block;
            position: relative;
            & > .remove-parent{
                position: absolute;
                top: 3px;
                right: 3px;
                cursor: pointer;
                width: 16px;
                height: 16px;
                text-align: center;
                line-height: 14px;
                border-radius: 50%;
                background-color: rgba(0, 0, 0, .5);
                & > .el-icon-close{
                    color: #ffffff;
                    font-size: 12px;
                    &:hover{
                        color: red;
                    }
                }
            }
        }
        & > .component-attach-list {
            list-style: none;
            margin: 0;
            padding: 0;
            line-height: 14px;
            margin-top: 9px !important;

            & > .component-attach-item {
                display: inline-block;
                margin: 0 10px 10px 0;

                & > span {
                    float: left;
                    max-width: 200px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }

        & > .upload-container-class {
            display: inline-block;
            & > .el-upload {
                & > .upload-icon {
                    font-size: 16px;
                    cursor: pointer;
                    color: #2196F3;
                    font-weight: 500;

                    &:hover {
                        color: #03a9f4;
                    }
                }
            }

            &.image > .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                width: 100%;
                height: 100%;
                text-align: center;
                font-size: 25px;

                &:hover {
                    border-color: #03a9f4;
                    color: #03a9f4;
                }

                & > img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .file-item-link{
            display: inline-block;
            width: 120px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            vertical-align: middle;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/NewUpload.vue